(() => {
  const CHECKOUT_START_URL = '/pages/checkout-start';

  function isHtmlElement(el) {
    return el && el.nodeType === 1;
  }

  function formatMoneyFromCents(cents, currency) {
    try {
      const value = (cents || 0) / 100;
      return new Intl.NumberFormat('ja-JP', {
        style: 'currency',
        currency: currency || 'JPY',
        maximumFractionDigits: 0,
      }).format(value);
    } catch (_) {
      return `${(cents || 0) / 100}`;
    }
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch cart');
    return await res.json();
  }

  function updateHeaderCartCount(itemCount) {
    const badge = document.getElementById('cart-count');
    if (!badge) return;
    badge.textContent = String(itemCount || 0);
  }

  function ensureModal() {
    let modal = document.getElementById('cart-added-modal');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = 'cart-added-modal';
    modal.className = 'cart-added-modal';
    modal.innerHTML = `
      <div class="cart-added-modal__backdrop" data-close="true" aria-hidden="true"></div>
      <div class="cart-added-modal__dialog" role="dialog" aria-modal="true" aria-label="カートに追加しました">
        <button type="button" class="cart-added-modal__close" aria-label="閉じる" data-close="true">×</button>
        <div class="cart-added-modal__title">カートに追加しました</div>
        <div class="cart-added-modal__summary" id="cart-added-summary"></div>
        <div class="cart-added-modal__actions">
          <a class="btn btn--primary cart-added-modal__btn" href="${CHECKOUT_START_URL}">会計に進む</a>
          <a class="btn btn--outline cart-added-modal__btn" href="/cart">カートを見る</a>
          <button type="button" class="btn btn--secondary cart-added-modal__btn" data-close="true">ショッピングを続ける</button>
        </div>
      </div>
    `;
    document.body.appendChild(modal);

    modal.addEventListener('click', (e) => {
      const t = e.target;
      if (!isHtmlElement(t)) return;
      if (t.dataset.close === 'true') closeModal();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeModal();
    });

    return modal;
  }

  function openModal(summaryHtml) {
    const modal = ensureModal();
    const summary = modal.querySelector('#cart-added-summary');
    if (summary) summary.innerHTML = summaryHtml || '';
    document.documentElement.classList.add('cart-modal-open');
    modal.classList.add('is-open');
  }

  function closeModal() {
    const modal = document.getElementById('cart-added-modal');
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('cart-modal-open');
  }

  function buildSummaryHtml(cart) {
    const itemCount = cart?.item_count ?? 0;
    const total = cart?.total_price ?? 0;
    const currency = cart?.currency;
    return `
      <div class="cart-added-modal__meta">
        <div>点数: <strong>${itemCount}</strong></div>
        <div>小計: <strong>${formatMoneyFromCents(total, currency)}</strong></div>
      </div>
    `;
  }

  async function addToCart(form) {
    const fd = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd,
      credentials: 'same-origin',
    });
    if (!res.ok) {
      let msg = 'カートに追加できませんでした。';
      try {
        const err = await res.json();
        if (err?.description) msg = err.description;
      } catch (_) {}
      throw new Error(msg);
    }
    return await res.json();
  }

  function setSubmitting(form, isSubmitting) {
    const btn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!btn) return;
    btn.disabled = isSubmitting;
    if (isSubmitting) btn.dataset.originalText = btn.textContent || '';
    if (isSubmitting) btn.textContent = '追加中...';
    else if (btn.dataset.originalText) btn.textContent = btn.dataset.originalText;
  }

  function attach() {
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (!isHtmlElement(form) || form.tagName !== 'FORM') return;
      const action = (form.getAttribute('action') || '').trim();
      if (!/\/cart\/add/i.test(action)) return;

      // Progressive enhancement: only AJAX when fetch is available
      if (typeof fetch !== 'function') return;

      e.preventDefault();
      try {
        setSubmitting(form, true);
        await addToCart(form);
        const cart = await fetchCart();
        updateHeaderCartCount(cart.item_count);
        openModal(buildSummaryHtml(cart));
      } catch (err) {
        alert(err?.message || 'カートに追加できませんでした。');
      } finally {
        setSubmitting(form, false);
      }
    });

    // Initialize cart badge count on load (best-effort)
    fetchCart()
      .then((cart) => updateHeaderCartCount(cart.item_count))
      .catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();

